import { makeStyles } from 'tss-react/mui'

export default makeStyles()(theme => ({
  card: {
    height: '100%',
  },
  cardActionArea: {
    height: '100%',
  },
  cardContent: {
    height: 'calc(100% - 192px)',
  },
  screenshot: {
    backgroundColor: 'rgb(220, 222, 226)',
    height: 192,
    position: 'relative',
  },
  description: {
    color: 'rgba(0, 0, 0, 0.7)',
    lineHeight: '1.25em',
    marginBottom: theme.spacing(2),
  },
  link: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  placeholder: {
    position: 'absolute',
    left: 0,
    top: 'calc(50% - 24px)',
    width: '100%',
    textAlign: 'center',
    opacity: '0.5',
  },
  placeholderIcon: {
    width: '48px !important',
    height: '48px !important',
  },
  buttonIcon: {
    marginRight: `${theme.spacing(2)} !important`,
  },
}))
